import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { PublicConfigService } from '@/app/core/config/public-config.service';

@Component({
  selector: 'app-support-widget',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './support-widget.html',
  styleUrl: './support-widget.scss',
})
export class SupportWidgetComponent implements OnInit, OnDestroy {
  readonly publicConfig = inject(PublicConfigService);
  private readonly router = inject(Router);

  readonly labelVisible = signal(true);
  readonly hiddenOnCurrentView = signal(false);

  private hideTimer?: ReturnType<typeof setTimeout>;
  private routeSub?: Subscription;

  ngOnInit(): void {
    this.publicConfig.load();
    this.updateVisibility(this.router.url);
    this.routeSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.updateVisibility(event.urlAfterRedirects));
    this.startHideTimer();
  }

  ngOnDestroy(): void {
    clearTimeout(this.hideTimer);
    this.routeSub?.unsubscribe();
  }

  private startHideTimer(): void {
    this.hideTimer = setTimeout(() => this.labelVisible.set(false), 7000);
  }

  onMouseEnter(): void {
    clearTimeout(this.hideTimer);
    this.labelVisible.set(true);
  }

  onMouseLeave(): void {
    this.startHideTimer();
  }

  private updateVisibility(url: string): void {
    const normalizedUrl = url.split('?')[0].split('#')[0];
    const hiddenRoute = normalizedUrl === '/cart' || normalizedUrl.startsWith('/checkout');

    this.hiddenOnCurrentView.set(hiddenRoute);
  }
}
